import { useState, useEffect } from 'react';
import CloseIcon from '../../../assets/icons/close.svg?react';
import { useUpdateCharger } from '../../../hooks/queries/chargerQueries';
// {
//   "cpoStationId": "string",
//   "cpoChargerId": "string",
//   "chargerCapacity": 0,
//   "extensionDataSysId": "string"
// }
const ChargerUpdateSideModal = ({onClose, onSuccess, onStationSearch, selectedStation, setSelectedStation, target}) => {
  const [chargerUpdateObject, setChargerUpdateObject] = useState({
    ChargerSysId: target.charger?.ChargerSysId,
    cpoStationId: target.stationInfo?.CpoStationId,
    cpoChargerId: target.charger?.CpoChargerId,
    chargerCapacity: target.charger?.ChargerCapacity,
    extensionDataSysId: target.charger?.ExtensionDataSysId,
    stationSysId: target.stationInfo?.StationSysId
  });

  // React Query mutation 훅을 컴포넌트 최상위 레벨에서 호출
  const updateChargerMutation = useUpdateCharger();

  useEffect(() => {
    if(selectedStation){
      setChargerUpdateObject(prev => ({ 
        ...prev,
        cpoStationId: selectedStation.CpoStationId, 
        stationSysId: selectedStation.StationSysId 
      }));
    }
  }, [selectedStation]);

  // target이 변경될 때 selectedStation을 초기화하지 않음
  // 대신 chargerUpdateObject만 업데이트
  useEffect(() => {
    if(target?.stationInfo){
      setChargerUpdateObject(prev => ({
        ...prev,
        cpoStationId: target.stationInfo.CpoStationId,
        stationSysId: target.stationInfo.StationSysId
      }));
    }
  }, [target]);

  const handleChargerUpdateObject = (e) => {
    setChargerUpdateObject({ ...chargerUpdateObject, [e.target.id]: e.target.value });
  };
  
  const handleChargerUpdate = async () => {
    if(!chargerUpdateObject.cpoChargerId || !chargerUpdateObject.chargerCapacity || !chargerUpdateObject.stationSysId){
      return;
    }
    
    try {
      // 1. 충전기 수정
      const chargerResponse = await updateChargerMutation.mutateAsync({ data: chargerUpdateObject });
      
      onSuccess(); // 추가 성공 시 콜백 호출
      onClose();
    } catch (error) {
      console.error('충전기 수정 실패:', error);
      alert('충전기 수정에 실패했습니다.');
    }
  };
  return (
    <div className="side-modal-background">
      <div className="side-modal-container">
        <div className="side-modal-header">
          <h3>충전기 수정</h3>
          <div className="side-modal-close" onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
        <div className="side-modal-content">
          <table className='transparent-table w-full'>
            <tr>  
              <td>
                <label htmlFor="cpoChargerId" className='w-20 mr-10 text-b2-700 required'>충전기 고유식별자</label>
              </td>
              <td>
                <input value={chargerUpdateObject.cpoChargerId} type="text" id="cpoChargerId" className='w-full input-primary' placeholder='충전기 고유식별자를 입력해주세요.' onChange={handleChargerUpdateObject}/>
              </td>
            </tr>
            {/* <p className='text-c2-400 text-gray-600'>충전기 고유식별자를 입력하세요</p> */}
            <tr>
              <td>
                  <label htmlFor="chargerCapacity" className='w-20 mr-10 text-b2-700 required'>용량(kWh)</label>
              </td>
              <td>
                  <input value={chargerUpdateObject.chargerCapacity} type="text" id="chargerCapacity" className='w-full input-primary' placeholder='용량을 입력해주세요.' onChange={handleChargerUpdateObject}/>
              </td>
            </tr>
            <tr>
              <td>
                  <label htmlFor="cpoStationId" className='w-20 mr-10 text-b2-700 required'>충전소 식별자</label>
              </td>
              <td>
                <input value={chargerUpdateObject.cpoStationId} type="text" id="cpoStationId" className='w-full input-primary' placeholder='충전소 검색을 통해 선택해주세요.' readOnly/>
              </td>
            </tr>
          </table>
          <div className='flex justify-end mb-10'>
            <button className='btn big-btn btn-style-2' onClick={onStationSearch}>충전소 검색</button>
          </div>
          <div className='flex justify-end'>
            <button 
              className='btn big-btn btn-primary w-full' 
              onClick={handleChargerUpdate}
              disabled={updateChargerMutation.isPending}
            >
              {(updateChargerMutation.isPending) ? '수정 중...' : '수정하기'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChargerUpdateSideModal